export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formularfelder Nr."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erforderliche ID fehlt"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie haben sich erfolgreich angemeldet, der Betrieb am Geldautomaten kann fortgesetzt werden"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setzen Sie die Transaktionen am Geldautomaten fort"])}
}